import { useLocation } from '@tanstack/react-router';
import { useLayoutEffect } from 'react';

export const LBScrollToTop = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
